export default $axios => ({
  fetch() {
    return $axios.$get('/v2/social-followers')
  },
  getServiceName: () => 'socialFollowersService',
})
